export const OFFLINE = 'OFFLINE';
export const VS_COM = 'VS_COM';
export const ONLINE = 'ONLINE';
